import { Injectable, inject } from '@angular/core';

import { APP_CONFIG } from '../config/app-config';
import { StorageKey } from '../storage/storage.keys';
import type { StorageKind } from '../storage/storage.models';
import { StorageService } from '../storage/storage.service';
import { toAuthToken } from './auth.mapper';
import type { AuthToken } from './auth.models';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  private readonly storage = inject(StorageService);
  private readonly kind: StorageKind = inject(APP_CONFIG).tokenStorage;

  get token(): AuthToken | null {
    const raw = this.storage.read(StorageKey.ACCESS_TOKEN, this.kind);

    return raw === null ? null : toAuthToken(raw);
  }

  get accessToken(): string | null {
    return this.storage.read(StorageKey.ACCESS_TOKEN, this.kind);
  }

  save(token: AuthToken): void {
    this.storage.write(StorageKey.ACCESS_TOKEN, token.accessToken, this.kind);
  }

  clear(): void {
    for (const kind of ['local', 'session', 'memory'] as const) {
      this.storage.remove(StorageKey.ACCESS_TOKEN, kind);
    }
  }

  deviceId(): string {
    const existing = this.storage.read(StorageKey.DEVICE_ID, 'local');

    if (existing !== null && existing.length > 0) {
      return existing;
    }

    const generated = createDeviceId();

    this.storage.write(StorageKey.DEVICE_ID, generated, 'local');

    return generated;
  }
}

function createDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `dev-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}
